import React, { Component } from 'react';
import Chart from "react-apexcharts";
import { postDashboardForm } from '../api/apiClient'
import { Circles } from 'react-loader-spinner'
import ExcelExport from '../ExcelExport/ExcelExport';
import { ROCELL_COLORS, VUT_CHART_COLORS } from '../theme/rocellTheme';
import { buildHorizontalBarChartOptions, getBarChartHeight } from '../theme/chartOptions';

export class VUTchart extends Component {
    constructor() {
        super()
        this.state = {
            options: buildHorizontalBarChartOptions([], 0, { colors: VUT_CHART_COLORS }),
            chartHeight: getBarChartHeight(0, true),
            series: [],
            isLoaded: false,
            filterSupplier: '',
            filterVehicleType: '',
            filterDateTo: '',
            filterDateFrom: '',
            sheetData:[],
            exportData:[],
            averageUtilization: null,
            suppliers: JSON.parse(localStorage.getItem('suppliers')),
            vehicleTypes: [
                { id: '', name: 'All Types' },
                { id: '1', name: '14.5 ft | 3 pallets' },
                { id: '2', name: '16.5 ft | 6 pallets' },
                { id: '4', name: '18.5 ft | 8 pallets' },
                { id: '6', name: '21 ft | 10 pallets' },
                { id: '7', name: '24.5 ft | 15 pallets' },
                { id: '8', name: '40 ft | 35 pallets' },
            ],

        };
        this.componentDidMount = this.componentDidMount.bind(this)
        this.filterChange = this.filterChange.bind(this)
        this.updateChart = this.updateChart.bind(this)
    }

    updateState(name, data) {
        const newSeries = {
            name: name,
            data: data
        };

        this.setState((prevState) => ({
            series: [...prevState.series, newSeries]
        }));
    }

    filterChange(key, event) {
        console.log(key + " " + event.target.value)
        if (key == 'to') {
            this.setState({ filterDateTo: event.target.value })
        } else if (key == 'from') {
            this.setState({ filterDateFrom: event.target.value })
        } else if (key == 'filterSupplier') {
            this.setState({ filterSupplier: event.target.value })
        } else if (key == 'filterVehicleType') {
            this.setState({ filterVehicleType: event.target.value })
        }

    }

    updateCategories(newCategories, maxValue = 0) {
        const chartHeight = getBarChartHeight(newCategories.length, true);
        this.setState({
            chartHeight,
            options: buildHorizontalBarChartOptions(newCategories, maxValue, { colors: VUT_CHART_COLORS }),
        });
    }

    findVehNoById(vehicles, veh_id) {
        const vehicle = vehicles.find((v) => v.veh_id === veh_id);
        return vehicle ? vehicle.veh_no : null;
    }

    getData(formData) {
        const API_URL = process.env.REACT_APP_API_URL
        const dataUrl = API_URL + "/Bi_dashboard_vut"
        const veh_no_data = [];
        const shp_avg_uitl_data = [];

        postDashboardForm(dataUrl, formData).then((response) => {
            if (response.data.success) {
                const reportData = response.data.data.vehicle_utilizations;
                const vehicleData = response.data.data.vehicles;
                const sheetDataTemp = [];
                const exportDataTemp = [];
                reportData.forEach(item => {
                    // const shp_avg_uitl = Number(item.shp_avg_uitl).toFixed(1);
                    // shp_avg_uitl_data.push(shp_avg_uitl);
                    // var veh_no = this.findVehNoById(vehicleData, item.veh_id)
                    // veh_no_data.push(veh_no);
                    sheetDataTemp.push({
                        "vehicle"            : item?.veh_no,
                        "supplier"           : item?.sup_name,
                        "shipment"           : item?.tms_shp_id,
                        "utilization"        : item?.utilization,
                        "vehicle_type"      :  item?.tms_vty_id === "1" ? "3 Pallet" :
                                               item?.tms_vty_id === "2" ? "6 Pallet" :
                                               item?.tms_vty_id === "4" ? "8 Pallet" :
                                               item?.tms_vty_id === "6" ? "10 Pallet" :
                                               item?.tms_vty_id === "7" ? "15 Pallet" :
                                               item?.tms_vty_id === "8" ? "35 Pallet" : "Unknown",
                        "average_utilization": item?.average_utilization
                    });
                    exportDataTemp.push({
                        "vehicle_type"       : item?.vehicle_type,
                        "sup_name"           : item?.sup_name,
                        "veh_no"             : item?.veh_no,
                        "shipment_no"        : item?.shipment_no,
                        "utilization"        : item?.utilization,
                        "average_utilization": item?.average_utilization
                    });
                });
                vehicleData.forEach(item=>{
                    console.log("ITEM",item)
                    veh_no_data.push(item.veh_no);
                    shp_avg_uitl_data.push(item.average_utilization);
                })
                const maxUtil = shp_avg_uitl_data.reduce(
                    (max, val) => Math.max(max, Number(val) || 0),
                    0
                );
                // Ignore empty / zero bar values when calculating the scorecard average
                const nonEmptyUtil = shp_avg_uitl_data
                    .map((val) => Number(val))
                    .filter((val) => Number.isFinite(val) && val > 0);
                const avgUtil = nonEmptyUtil.length
                    ? nonEmptyUtil.reduce((sum, val) => sum + val, 0) / nonEmptyUtil.length
                    : 0;
                this.setState({
                    sheetData: sheetDataTemp,
                    exportData: exportDataTemp,
                    series: [],
                    averageUtilization: avgUtil.toFixed(1),
                    chartHeight: getBarChartHeight(veh_no_data.length, true),
                    options: buildHorizontalBarChartOptions(veh_no_data, maxUtil, { colors: VUT_CHART_COLORS }),
                })
                this.updateState("Average Utilization", shp_avg_uitl_data)
                this.updateLoader(true)
            } else {
                console.log("No data returned from API")
                this.setState({ averageUtilization: null })
                this.updateLoader(true)
            }

        }).catch(function (error) {
            console.log(error);
        });

    }

    updateLoader(stateValue) {
        if (this.state.isLoaded === true) {
            this.setState({ isLoaded: false })
        } else {
            this.setState({ isLoaded: stateValue })
        }
    }

    updateChart() {
        const newToDate = this.state.filterDateTo;
        const newFromDate = this.state.filterDateFrom;
        const filterSupplier = this.state.filterSupplier;
        const filterVehicleType = this.state.filterVehicleType;

        const formData = new FormData();
        formData.append('filter_date_from', newFromDate);
        formData.append('filter_date_to', newToDate);
        formData.append('supplier_id', filterSupplier);
        formData.append('vehicle_type_id', filterVehicleType);
        this.setState({ isLoaded: false })
        this.getData(formData);
    }

    componentDidMount() {
        const formData = new FormData();

        var currentDate = new Date();
        currentDate = new Date(currentDate.getTime() - 86400000);
        var formattedDateFrom = currentDate.toISOString().split('T')[0];

        currentDate = new Date();
        var formattedDateTo = currentDate.toISOString().split('T')[0];

        formData.append('filter_date_from', formattedDateFrom);
        formData.append('filter_date_to', formattedDateTo);
        formData.append('supplier_id', '7');
        formData.append('vehicle_type_id', '');

        this.setState({ filterDateFrom: formattedDateFrom })
        this.setState({ filterDateTo: formattedDateTo })
        this.setState({ filterSupplier: '7' })
        this.setState({ filterVehicleType: '' })
        this.getData(formData);

    }

    render() {
        return (
            <div className='card bi-chart-card'>
                <div className='card-header border-0'>
                    <div className='bi-vut-header'>
                        <div className='bi-vut-header__left'>
                            <p className='card-title mb-0'>
                                <span className='card-label fw-bold'>
                                    Vehicle Utilization
                                    <span className='bi-date-muted d-block mt-1'>{this.state.filterDateFrom} to {this.state.filterDateTo}</span>
                                </span>
                            </p>
                            <div className='bi-chart-actions justify-content-start'>
                                <button
                                    type='button'
                                    className='btn btn-sm btn-light-primary'
                                    data-kt-menu-trigger='click'
                                    data-kt-menu-placement='bottom-end'
                                    data-kt-menu-flip='top-end'>
                                    <i className='fas fa-filter me-1'></i> Filter
                                </button>
                                <ExcelExport data={this.state.sheetData} fileName="Vehicle Utilization" />

                                <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
                                    <div className='px-7 py-5'>
                                        <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
                                    </div>

                                    <div className='separator border-gray-200'></div>

                                    <div className='px-7 py-5'>
                                        <div className='mb-10'>
                                            <label className='form-label fw-bold'>Filter From Date:</label>
                                            <div>
                                                <input type="Date" name='date' value={this.state.filterDateFrom}
                                                    onChange={(event) => this.filterChange('from', event)}
                                                    className='form-control' />
                                            </div>
                                        </div>

                                        <div className='mb-10'>
                                            <label className='form-label fw-bold'>Filter To Date:</label>
                                            <div>
                                                <input type="Date" name='date' value={this.state.filterDateTo}
                                                    onChange={(event) => this.filterChange('to', event)}
                                                    className='form-control' />
                                            </div>
                                        </div>

                                        <div className='mb-10'>
                                            <label className='form-label fw-bold'>Filter Supplier:</label>
                                            <div>
                                                <select name='suppliers' id='suppliers' className='form-control'
                                                    value={this.state.filterSupplier}
                                                    onChange={(event) => this.filterChange('filterSupplier', event)}>
                                                    {this.state.suppliers.map((supplier) => (
                                                        <option key={supplier.sup_id} value={supplier.sup_id}>
                                                            {supplier.sup_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className='mb-10'>
                                            <label className='form-label fw-bold'>Vehicle Size-Wise:</label>
                                            <div>
                                                <select name='vehicleTypes' id='vehicleTypes' className='form-control'
                                                    value={this.state.filterVehicleType}
                                                    onChange={(event) => this.filterChange('filterVehicleType', event)}>
                                                    {this.state.vehicleTypes.map((vehicleType) => (
                                                        <option key={vehicleType.id || 'all'} value={vehicleType.id}>
                                                            {vehicleType.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className='d-flex justify-content-end'>
                                            <button
                                                type='reset'
                                                className='btn btn-sm btn-white btn-active-light-primary me-2'
                                                data-kt-menu-dismiss='true'>
                                                Reset
                                            </button>

                                            <button type='submit' className='btn btn-sm btn-primary' data-kt-menu-dismiss='true' onClick={this.updateChart}>
                                                Apply
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='bi-avg-scorecard'>
                            <div className='bi-avg-scorecard__label'>Average Utilization</div>
                            <div className='bi-avg-scorecard__value'>
                                {this.state.averageUtilization != null ? `${this.state.averageUtilization}%` : '—'}
                            </div>
                        </div>
                    </div>
                </div>

                <div className='card-body'>
                    <div className='row g-4'>
                        <div className='col-12'>
                            <div className={`bi-chart-area bi-chart-area--bar${!this.state.isLoaded ? ' bi-chart-area--loading' : ''}`}>
                                {!this.state.isLoaded ? (
                                    <Circles
                                        height="80"
                                        width="80"
                                        color={ROCELL_COLORS.accent}
                                        ariaLabel="circles-loading"
                                        visible={true}
                                    />
                                ) : (
                                    <Chart
                                        options={this.state.options}
                                        series={this.state.series}
                                        type="bar"
                                        width="100%"
                                        height={this.state.chartHeight}
                                    />
                                )}
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='bi-table-scroll'>
                                <table className='table table-bordered bi-data-table'>
                                    <thead>
                                        <tr>
                                            <th className='text-center'>Vehicle Type</th>
                                            <th className='text-center'>Supplier Name</th>
                                            <th className='text-center'>Vehicle Number</th>
                                            <th className='text-center'>Shipment Number</th>
                                            <th className='text-center'>Vehicle Utilization</th>
                                            <th className='text-center'>Average Utilization</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.exportData.map((record,index) => (
                                        <tr key={index}>
                                            <td className='text-center'>{record.vehicle_type}</td>
                                            <td className='text-center'>{record.sup_name}</td>
                                            <td className='text-center'>{record.veh_no}</td>
                                            <td className='text-center'>{record.shipment_no}</td>
                                            <td className='text-center'>{record.utilization}</td>
                                            <td className='text-center'>{record?.average_utilization}</td>
                                        </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}